import { withJsonFormsControlProps } from '@jsonforms/react';
import DOMPurify from 'dompurify';
import { Paper, Stack } from '@rossum/ui/material';

export const PromptResultControl = withJsonFormsControlProps(
  ({
    data: { text },
  }: {
    data: {
      text: string;
    };
  }) => {
    const sanitizer = DOMPurify.sanitize;

    return (
      <Paper elevation={8} sx={{ maxWidth: 600 }}>
        <Stack
          px={2}
          py={1}
          mb={2}
          // oxlint-disable-next-line react/no-danger -- oxlint stricter than eslint — sanitized HTML, pre-existing usage
          dangerouslySetInnerHTML={{ __html: sanitizer(text) }}
        />
      </Paper>
    );
  }
);
